import styled from "styled-components";

export const FabContainer = styled.div`
  position: fixed;
  bottom: 36px;
  right: 36px;
  z-index: 1000;

  @media (max-width: 849px) {
    bottom: calc(64px + env(safe-area-inset-bottom, 0px) + 16px);
    right: 16px;
  }
`;
